import React, { useRef, useState, useEffect, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatModal from '@components/common/satUI/SatModal';

import {
  getProdGroupList,
  getProdGroupCnt,
} from '@store/actions/managementProductAction';
import ProductDelRow from '@components/management/system/product/ProductDelRow';

import { showModal } from '@store/actions/commonAction';

const GroupModifyPop = props => {
  const { isOpen, data, onClose, onSave } = props;

  const { prodGroupListPop, prodGroupListPopCnt } = useSelector(
    state => state.managementProductReducer,
  );

  const dispatch = useDispatch();

  const [title, setTitle] = useState('');
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    if (prodGroupListPop.length > 0) {
      setTitle(data.orgChnlNm);

      const grpNmSplit = prodGroupListPop[0].saleProdGrpNm.split(',');
      const grpCdSplit = prodGroupListPop[0].saleProdGrpCd.split(',');

      let tmpArr = [];
      for (let i = 0; i < grpNmSplit.length; i++) {
        tmpArr.push({
          saleProdGrpCd: grpCdSplit[i],
          saleProdGrpNm: grpNmSplit[i],
          orgChnlCd: prodGroupListPop[0].orgChnlCd,
          count: prodGroupListPopCnt.filter(
            item => item.saleProdGrpCd === grpCdSplit[i],
          )[0]?.saleProdGrpCnt,
          rowIndex: i,
        });
      }
      setGridData(tmpArr);
    }

    // prodGroupListPopCnt
    // {saleProdGrpCd: '3', saleProdGrpCnt: '22'}
    // {saleProdGrpCd: '1', saleProdGrpCnt: '1'}
    // {saleProdGrpCd: '2', saleProdGrpCnt: '2'}
    // {saleProdGrpCd: '4', saleProdGrpCnt: '9'}

    // prodGroupListPop
    // {saleProdGrpCd: '1,2,3,4,5', saleProdGrpNm: '종신,연금/저축보험,변액,건강,정기', orgChnlCd: '1008'}
  }, [prodGroupListPopCnt]);

  useEffect(() => {
    dispatch(
      getProdGroupList({
        orgChnlCd: data.orgChnlCd,
      }),
    );

    dispatch(
      getProdGroupCnt({
        orgChnlCd: data.orgChnlCd,
      }),
    );
  }, [data]);

  useEffect(() => {
    // console.log(gridData)
  }, [gridData]);

  const onInputChangeHandler = (e, rowIndex) => {
    const { value, name } = e.target;

    let newArr = [...gridData];
    newArr[rowIndex][name] = value;
    setGridData(newArr);
  };

  const onAddButtonHandler = () => {
    if (gridData.length >= 8) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '상품군은 8개까지 등록이 가능합니다.',
        }),
      );
      return;
    }

    let newArr = [...gridData];
    const grpCdSplit = prodGroupListPop[0].saleProdGrpCd.split(',');
    newArr.push({
      // saleProdGrpCd : (Number(grpCdSplit[grpCdSplit.length-1])+1).toString(),
      saleProdGrpCd: (Number(newArr.length) + 1).toString(),
      saleProdGrpNm: '',
      orgChnlCd: prodGroupListPop[0].orgChnlCd,
      count: 0,
      rowIndex: gridData.length,
      status: 'add',
    });
    setGridData(newArr);
  };

  const onSaveHandler = () => {
    const length = gridData.filter(
      item => item.saleProdGrpNm === '' && item.status !== 'del',
    ).length;

    if (length > 0) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '상품군을 입력해주세요.',
        }),
      );
      return;
    }

    // console.log(gridData.filter(item => item.status !== 'del'));
    onSave(gridData.filter(item => item.status !== 'del'));
  };
  return (
    <>
      <SatModal visible={isOpen} type="newInfo">
        <h3 className="layer-tit2">상품군 편집</h3>
        <div className="cont">
          <div className="modal-tbl">
            <div className="table-wrap-reg">
              <h4 className="layer-tit3">
                {title} : 상품군{' '}
                {gridData.filter(item => item.status !== 'del').length}/8
              </h4>
              <div className="table-wrap mgb-0 table-wrap-scroll">
                <table className="tbl-sty1">
                  <colgroup>
                    <col width={'40%'}></col>
                    <col width={'30%'}></col>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>상품군</th>
                      <th>상품개수</th>
                      <th>버튼</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridData.map((item, index) => (
                      <ProductDelRow
                        key={`key_prdtRow-${index}`}
                        data={item}
                        onInputChange={(e, rowIndex) => {
                          onInputChangeHandler(e, rowIndex);
                        }}
                        onDelete={(e, rowIndex) => {
                          if (e.target.classList.value.includes('disabled')) {
                            return;
                          }

                          let newArr = [...gridData];
                          newArr[
                            gridData.filter(
                              item => item.rowIndex === rowIndex,
                            )[0].rowIndex
                          ].status = 'del';
                          setGridData(newArr);
                        }}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="btn-r-fix">
                <button className="btn-m add" onClick={onAddButtonHandler}>
                  추가
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="btn-area btn-area-r">
          <button className="btn-m save" onClick={() => onSaveHandler()}>
            저장
          </button>
        </div>
        <button
          className="btn-layer-close modal-close"
          onClick={() => {
            let newArr = [...gridData];
            let tmpIndexArr = [];
            newArr.forEach((item, index) => {
              if (item.status === 'add') {
                tmpIndexArr.push(index);
              }
            });
            for (let i = tmpIndexArr.length; i > 0; i--) {
              newArr.splice(tmpIndexArr[i - 1], 1);
            }

            newArr.forEach(item => {
              item.status = '';
            });
            setGridData(newArr);

            onClose();
          }}
        >
          창닫기
        </button>
      </SatModal>
    </>
  );
};

export default memo(GroupModifyPop);
